// src/data/dashboardConfig.ts

// --- Data Types ---
interface ProjectSummary {
    icon: string; // antd icon name (e.g., 'CheckCircleOutlined')
    count: number;
    label: string;
    status: 'completed' | 'required' | 'in-progress' | 'delayed';
}

interface ProjectDetail {
    title: string;
    company: string;
    progress: number; // 0-100
    dueDate: string; // e.g., '13 Oct 2025'
    statusLabel: string; // e.g., 'On Track', '4 days Delayed', 'Behind Target'
    statusColor: 'success' | 'warning' | 'error';
}

interface AccountSummaryItem {
    label: string;
    value: string | number;
}

// --- Mock Data ---
export const projectSummaries: ProjectSummary[] = [
    { icon: 'CheckCircleOutlined', count: 144, label: 'Total Projects Completed', status: 'completed' },
    { icon: 'FileTextOutlined', count: 4, label: 'Required this month', status: 'required' },
    { icon: 'ClockCircleOutlined', count: 3, label: 'Currently in Progress', status: 'in-progress' },
    { icon: 'WarningOutlined', count: 1, label: 'Delayed Project', status: 'delayed' },
];

export const projectDetails: ProjectDetail[] = [
    {
        title: 'SaaS Website Revamp',
        company: 'Nexa Technologies',
        progress: 60,
        dueDate: '13 Oct 2025',
        statusLabel: 'On Track',
        statusColor: 'success',
    },
    {
        title: 'E-Commerce App',
        company: 'Nexa Technologies',
        progress: 60,
        dueDate: '13 Oct 2025',
        statusLabel: '4 days Delayed',
        statusColor: 'warning',
    },
    {
        title: 'E-Commerce App',
        company: 'Nexa Technologies',
        progress: 60,
        dueDate: '13 Oct 2025',
        statusLabel: 'Behind Target',
        statusColor: 'error',
    },
];

export const accountOverviewData = {
    target: 30,
    added: 5,
    status: 'On Track',
    summaryItems: [
        { label: 'Created this week', value: 5 },
        { label: 'Avg. per week', value: 5 },
        { label: 'Completion rate', value: '85%' },
        { label: 'Remaining', value: 1 },
    ] as AccountSummaryItem[],
    recentlyAdded: [
        { name: 'Nexa Technologies', role: 'account no' },
        { name: 'SaaS Website Revamp', role: 'account no' },
    ],
};